var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10.45,
    height: 9.143,
    viewBox: "0 0 10.45 9.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Color",
    d: "M.653,5.225H8.4L6.029,8.072a.653.653,0,0,0,1,.836L10.3,4.99a.611.611,0,0,0,.057-.1.619.619,0,0,0,.046-.081.644.644,0,0,0,.047-.234V4.569a.644.644,0,0,0-.047-.234.619.619,0,0,0-.046-.081.611.611,0,0,0-.057-.1L7.033.235a.653.653,0,0,0-1,.836L8.4,3.919H.653a.653.653,0,0,0,0,1.306",
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(-4 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Color-2",
    "data-name": "Color",
    d: "M.653,5.225H8.4L6.029,8.072a.653.653,0,0,0,1,.836L10.3,4.99a.611.611,0,0,0,.057-.1.619.619,0,0,0,.046-.081.644.644,0,0,0,.047-.234V4.569a.644.644,0,0,0-.047-.234.619.619,0,0,0-.046-.081.611.611,0,0,0-.057-.1L7.033.235a.653.653,0,0,0-1,.836L8.4,3.919H.653a.653.653,0,0,0,0,1.306",
    transform: "translate(4 5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.3cc6d5bd6314db6db9cba48bc770a70c.svg";
export { ForwardRef as ReactComponent };